import {checkIfCouldManeuverFromHex} from "./checkIfCouldManeuverFromHex";

// Право на манёвр даёт участие отряда в этапе войны ЛЮБЫМ доступным ему
// действием (стрельба/ближний бой — для всех фракций; попытка соблазнения у
// Суккубов, любая способность у Гоблинов — общий флаг hasUsedAbilityThisWarPhase,
// см. configs/units.js), а не только боем — это общее правило игры, а не
// особый случай отдельной фракции (см. add-goblins-faction design.md, пункт
// 10.17 ручного тестирования)
export const checkIfUnitCouldManeuverFromHex = (owner, unit, hexes) => {
  return !!unit.additionalSupply
    && checkIfCouldManeuverFromHex(owner, hexes, unit.hexKey)
    && (
      unit.hasShotThisWarPhase
      || unit.hasFoughtThisWarPhase
      || unit.hasUsedAbilityThisWarPhase
    );
}
